<flexyoo-generic-page-with-logo>
  <ng-container content>
    <div class="flexyoo-login-form">
      @if (showMailResponse$ | async) {
        <mat-card appearance="outlined">{{ 'general.forgot-mail-response' | translate }}</mat-card>
      } @else {
        <form id="LoginForm" [formGroup]="form" (ngSubmit)="submit()">
          <mat-form-field>
            <input
              formControlName="email"
              matInput
              type="email"
              placeholder="{{ 'general.email' | translate }}"
            />
            @if (form.controls.email.errors?.email) {
              <mat-error>{{ 'errors.invalid-email-format' | translate }}</mat-error>
            }
          </mat-form-field>
          <button
            matButton="filled"
            style="display: block; font-size: 20px; margin: 10px auto 0"
            type="submit"
            [disabled]="!form.enabled" class="fo-color-secondary"
          >
            {{ 'both-languages.confirm' | translate }}
          </button>
        </form>
      }
      <br />
      <a routerLink="/login" style="color: black; cursor: pointer"
        ><< {{ 'auth.back-to-login' | translate }}</a
      >
    </div>
  </ng-container>
</flexyoo-generic-page-with-logo>
